import {
  createEnumOptions,
  IBaseFlowStepData,
  IOrder,
  IOrderItem,
  OrderStatus,
  SelectionItem,
} from '@kinet-open-network/shared/data-access/model';
import {
  IFlowOrderScannedItem,
  IFlowOrderSelectionItemData,
} from '../orders/flow-order.interface';
import { IAppStockItem } from '../stock/app-stock-item.interface';

export type GoodsReceiptStatus =
  | OrderStatus.draft
  | OrderStatus.approved
  | OrderStatus.delivered;

export const goodsReceiptStatuses: GoodsReceiptStatus[] = [
  OrderStatus.draft,
  OrderStatus.approved,
  OrderStatus.delivered,
];

export const goodsReceiptStatusOptions = createEnumOptions<GoodsReceiptStatus>({
  [OrderStatus.draft]: {
    label: 'Rozpracovaný',
    color: 'none',
    icon: 'pi pi-pencil',
  },
  [OrderStatus.approved]: {
    label: 'Potvrdený',
    color: 'primary',
    icon: 'pi pi-check',
  },
  [OrderStatus.delivered]: {
    label: 'Doručený',
    color: 'success',
    icon: 'pi pi-home',
  },
  _default: { label: '-' },
});

export enum FlowGoodsReceiptActions {
  changeStatus = 'changeStatus',
}

export const flowGoodsReceiptActionsOptions =
  createEnumOptions<FlowGoodsReceiptActions>({
    [FlowGoodsReceiptActions.changeStatus]: {
      label: 'Zmeniť stav',
      icon: 'pi pi-check',
    },
    _default: { label: '-' },
  });

export interface IGoodsReceiptItem extends IOrderItem<'GoodsReceipt'> {
  /** Plná fľaša (prijatá od dodávateľa). */
  isFull?: boolean | null;

  /** Prázdna fľaša vrátená dodávateľovi. */
  isComplaint?: boolean | null;

  stockItem?: IAppStockItem;
}

export type GoodsReceiptSelectionItem = SelectionItem<
  IFlowOrderSelectionItemData,
  IFlowOrderScannedItem
>;

export interface IFlowGoodsReceipt extends IOrder<'GoodsReceipt'> {
  items: IGoodsReceiptItem[];

  status: GoodsReceiptStatus;

  /** Plné fľaše prijaté od dodávateľa. */
  receivedItems?: GoodsReceiptSelectionItem[];

  /** Prázdne fľaše odovzdané dodávateľovi. */
  returnedItems?: GoodsReceiptSelectionItem[];
}

export interface IFlowGoodsReceiptStepData extends IBaseFlowStepData {
  receivedItems?: GoodsReceiptSelectionItem[];

  returnedItems?: GoodsReceiptSelectionItem[];

  autoSaveItems?: boolean;
}
